import { ContextHolder } from '@frontegg/react';

function useLogout(redirectToCurrentPage?: boolean) {
  return () => {
    const { baseUrl } = ContextHolder.getContext();
    window.location.href = `${baseUrl}/oauth/logout?post_logout_redirect_uri=${
      redirectToCurrentPage ? window.location : window.location.origin
    }`;
  };
}

export default useLogout;
